import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {ApolloQueryObservable} from "apollo-angular";
import {StocktakingService} from "../../../services/stocktaking/stocktaking.service";
import {StocktakingType} from "../../model/stocktaking-type.type";
import {FormBuilder, FormGroup} from "@angular/forms";
import {DepotStocktakingComponent} from "../../components/depot-stocktaking-form/depot-stocktaking.component";
import {StocktakingFormComponent} from "../../components/stocktaking-form/stocktaking-form.component";
import {intersectFormGroups, mergeFormGroups} from "../../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {ActivatedRoute, Router} from "@angular/router";

export const STOCKTAKING_TYPE_DEPOT = 'cj6p363l40001ugt9bipbcnkl';
export const STOCKTAKING_TYPE_MEDICINE = 'cj6p363l40003ugt9cuzfvayc';

@Component({
  selector: 'vb-init-stocktaking-view',
  templateUrl: './init-stocktaking-view.component.html',
  styleUrls: ['./init-stocktaking-view.component.css']
})
export class InitStocktakingViewComponent extends AbstractVisbosComponent implements OnInit {

  private stocktakingTypes$: ApolloQueryObservable<any>;
  stockTakingTypes: StocktakingType[];

  selectedStocktakingType: StocktakingType;
  showDepotControl: boolean = false;

  formHorizontal = false;
  control: FormGroup;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder,
              private stocktakingService: StocktakingService,
              private router: Router, private route: ActivatedRoute) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.initGeneralStocktaking();

    this.stocktakingTypes$ = this.stocktakingService.getStocktakingTypes();
    this.addComponentData(this.stocktakingTypes$);
    this.addSubscription(this.stocktakingTypes$.subscribe(res => {
      this.stockTakingTypes = res.data.stocktakingTypes;
    }));

  }

  onStocktakingTypeSelected(type: StocktakingType) {

    if (type) {
      this.selectedStocktakingType = type;
      if (type.cuid == STOCKTAKING_TYPE_DEPOT) { // Lagerinventur ausgewählt
        this.initDepotStocktaking();
        this.showDepotControl = true;
      } else if (type.cuid == STOCKTAKING_TYPE_MEDICINE) {
        this.initMedicineStocktaking();
        this.showDepotControl = true;
      } else {
        this.initGeneralStocktaking();
        this.showDepotControl = false;
      }
    }

  }

  initDepotStocktaking() {
    mergeFormGroups(this.control, DepotStocktakingComponent.initControl(this.fb));
  }

  initMedicineStocktaking() {
    mergeFormGroups(this.control, DepotStocktakingComponent.initControl(this.fb));
  }

  initGeneralStocktaking() {
    if (!this.control) {
      this.control = StocktakingFormComponent.initControl(this.fb);
    } else {
      // Remove unused controls from group, keep only general ones
      intersectFormGroups(this.control, StocktakingFormComponent.initControl(this.fb));
    }
  }

  onInitStocktakingClicked() {
    if (this.selectedStocktakingType.cuid == STOCKTAKING_TYPE_DEPOT) {
      let depotCuid = this.control.get('depot_id').value;
      this.stocktakingService.initDepotStocktaking(depotCuid, this.control.value).subscribe(res => {
          this.router.navigate(['../', res.data.createDepotStocktaking.cuid], {relativeTo: this.route});
        },
        err => {
          this.sessionActions.throwError(err, "Fehler beim Anlegen der Inventur, bitte wenden Sie sich an den Support!", "Inventur");
        });
    }

    if (this.selectedStocktakingType.cuid == STOCKTAKING_TYPE_MEDICINE) {
      let depotCuid = this.control.get('depot_id').value;
      this.stocktakingService.initMedicineStocktaking(depotCuid, this.control.value).subscribe(res => {
          this.router.navigate(['../', res.data.createMedicineStocktaking.cuid], {relativeTo: this.route});
        },
        err => {
          this.sessionActions.throwError(err, "Fehler beim Anlegen der Inventur, bitte wenden Sie sich an den Support!", "Inventur");
        });
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stocktaking/views/init-stocktaking-view/init-stocktaking-view.component.ts